const DATA = 'data: '

const framed = <Frame>(chunk: string): Frame[] =>
  chunk
    .split('\n')
    .filter((line) => line.startsWith(DATA))
    .flatMap((line) => {
      try {
        return [JSON.parse(line.slice(DATA.length)) as Frame]
      } catch {
        return []
      }
    })

export async function* framesOf<Frame>(body: ReadableStream<Uint8Array>): AsyncGenerator<Frame> {
  const reader = body.getReader()
  const decoder = new TextDecoder()

  let held = ''

  while (true) {
    const { done, value } = await reader.read()

    if (done) break

    held += decoder.decode(value, { stream: true })

    const frames = held.split('\n\n')

    held = frames.pop() ?? ''

    for (const frame of frames) yield* framed<Frame>(frame)
  }

  yield* framed<Frame>(held + decoder.decode())
}
